import React, { useState } from "react";
import {
  House,
  ClipboardList,
  ShoppingBag,
  Package,
  ChartNoAxesCombined,
  Settings as SettingsIcon,
  Users,
  Store,
  Plug,
  Eye,
  ArrowUpRight,
  Bell,
  LogOut,
  Menu,
  HelpCircle,
  ChevronDown,
  Mail,
} from "lucide-react";
import { Brand, Button, Field, Modal, ProductCard, PageHead } from "./ui";
import { api, demo, supabase, config, rpc } from "./data";
import { Products, Categories, Inventory, Bulk } from "./products";
import { Orders, ManualOrder, OrderDetail, Customers } from "./orders";
import { Dashboard } from "./dashboard";
import { Settings, Team, Integrations, Marketing } from "./settings";
export function Admin(props) {
  const { data, user, route, run, refresh, onUser } = props;
  const [menu, setMenu] = useState(false),
    [notifications, setNotifications] = useState(false),
    [help, setHelp] = useState(false);
  if (!data?.store || !data.members.some((m) => m.user_id === user.id))
    return <Onboarding {...props} />;
  const key = route.split("?")[0].split("/")[1] || "dashboard",
    id = route.split("/")[2];
  const member = data.members.find((m) => m.user_id === user.id);
  const name = member?.name || "Mi tienda";
  const pending = data.orders.filter((o) => o.status === "Pendiente");
  const low = data.variants.filter((v) => v.active && v.stock <= v.low_stock);
  const nav = (slug, title, Icon) => (
    <a
      key={slug}
      className={key === slug ? "active" : ""}
      href={`#admin/${slug}`}
      onClick={() => setMenu(false)}
    >
      <Icon size={18} />
      {title}
    </a>
  );
  const sub = (slug, title) => (
    <a
      key={slug}
      className={
        key === slug.split("/")[0] &&
        (slug.split("/")[0] !== "settings" || id === slug.split("/")[1])
          ? "active"
          : ""
      }
      href={`#admin/${slug}`}
      onClick={() => setMenu(false)}
    >
      {title}
    </a>
  );
  async function logout() {
    if (demo) {
      sessionStorage.removeItem("dilo-demo-admin");
      onUser(null);
    } else await supabase.auth.signOut();
    location.hash = "#login";
  }
  let view;
  if (key === "products" || key === "editor" || key === "sort")
    view = <Products {...props} view={key} />;
  else if (key === "categories") view = <Categories {...props} />;
  else if (key === "inventory" || key === "variants")
    view = <Inventory {...props} />;
  else if (key === "bulk") view = <Bulk {...props} />;
  else if (key === "orders") view = <Orders key={route} {...props} />;
  else if (key === "manual") view = <ManualOrder {...props} />;
  else if (key === "order") view = <OrderDetail id={id} {...props} />;
  else if (key === "customers") view = <Customers {...props} />;
  else if (key === "team") view = <Team {...props} />;
  else if (key === "settings")
    view = <Settings key={id} section={id || "general"} {...props} />;
  else if (key === "integrations") view = <Integrations {...props} />;
  else if (key === "marketing") view = <Marketing {...props} />;
  else if (key === "catalog")
    view = (
      <>
        <PageHead
          title="Catálogo de productos"
          description="Imprime el catálogo o elige Guardar como PDF en la ventana de impresión."
          actions={
            <Button onClick={() => window.print()}>
              Imprimir / Guardar PDF
            </Button>
          }
        />
        <div className="print-only">
          <h1>{data.store.name}</h1>
          <p>{data.store.whatsapp}</p>
        </div>
        <div className="catalog-print products-grid admin-products">
          {data.products
            .filter((p) => p.active)
            .map((p) => (
              <ProductCard
                key={p.id}
                product={p}
                variants={data.variants}
                onSelect={() => (location.hash = "#admin/products")}
                adminActions={<small>{p.sku}</small>}
              />
            ))}
        </div>
      </>
    );
  else view = <Dashboard {...props} />;
  return (
    <div className="admin-shell">
      <aside className={`sidebar ${menu ? "open" : ""}`}>
        <div className="sidebar-brand">
          <Brand small />
          <div>
            Dilo Shop<small>MI TIENDA</small>
          </div>
        </div>
        <div className="sidebar-label">ADMINISTRACIÓN DE TIENDA</div>
        <nav>
          {nav("dashboard", "Inicio", House)}
          <details open>
            <summary
              className={
                ["orders", "manual", "order"].includes(key) ? "active" : ""
              }
            >
              <ClipboardList size={18} /> Mis pedidos <ChevronDown size={13} />
            </summary>
            {sub("orders", "Pedidos")}
            {sub("manual", "Crear pedido manual")}
          </details>
          <details open>
            <summary
              className={
                [
                  "products",
                  "sort",
                  "editor",
                  "bulk",
                  "categories",
                  "variants",
                  "catalog",
                ].includes(key)
                  ? "active"
                  : ""
              }
            >
              <ShoppingBag size={18} /> Productos <ChevronDown size={13} />
            </summary>
            {sub("products", "Mis productos")}
            {sub("sort", "Ordenar productos")}
            {sub("editor", "Editor de productos")}
            {sub("bulk", "Creación / edición masiva")}
            {sub("categories", "Categorías y subcategorías")}
            {sub("variants", "Variantes de producto")}
            {sub("catalog", "Catálogo en PDF")}
          </details>
          {nav("inventory", "Inventario", Package)}
          {nav("marketing", "Marketing", ChartNoAxesCombined)}
          {nav("customers", "Clientes", Users)}
          {nav("team", "Colaboradores", Users)}
          <details>
            <summary className={key === "settings" ? "active" : ""}>
              <SettingsIcon size={18} /> Configuración <ChevronDown size={13} />
            </summary>
            {sub("settings/general", "Datos de tienda")}
            {sub("settings/payments", "Pagos y entregas")}
          </details>
          <div className="sidebar-label" style={{ marginTop: 15 }}>
            CANALES DE VENTA
          </div>
          <details open>
            <summary>
              <Store size={18} /> Tienda virtual <ChevronDown size={13} />
            </summary>
            {sub("settings/appearance", "Aspecto y banner")}
            {sub("settings/pages", "Páginas")}
            {sub("settings/domain", "Dominio")}
            {sub("settings/social", "Redes sociales")}
            {sub("settings/blog", "Blog")}
          </details>
          {nav("integrations", "Integraciones", Plug)}
        </nav>
        <div className="sidebar-bottom">
          <img src="/assets/icono.png" alt="Dilo" />
          <div>
            <strong>Tu negocio, a tu manera.</strong>
            <small>Dilo Shop · Inventario y ventas</small>
          </div>
        </div>
      </aside>
      <div className="admin-main">
        <header className="admin-topbar">
          <div className="breadcrumb">
            <button
              className="icon-btn menu-toggle"
              aria-label="Abrir menú"
              onClick={() => setMenu(!menu)}
            >
              <Menu size={20} />
            </button>
            Dilo Shop <span>/ Administración</span>
          </div>
          <div className="actions">
            <a className="store-link" href="/" target="_blank" rel="noreferrer">
              <Eye size={17} /> VER TIENDA <ArrowUpRight size={14} />
            </a>
            <button
              className="icon-btn"
              style={{ position: "relative" }}
              aria-label="Notificaciones"
              onClick={() => setNotifications(true)}
            >
              <Bell size={18} />
              {pending.length + low.length > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    background: "#743ed1",
                    color: "white",
                    fontSize: 10,
                    borderRadius: 10,
                    padding: "0 4px",
                  }}
                >
                  {pending.length + low.length}
                </span>
              )}
            </button>
            <div className="admin-user">
              <div className="avatar">{name.slice(0, 2).toUpperCase()}</div>
              <span>{name}</span>
            </div>
            <button
              className="icon-btn"
              aria-label="Cerrar sesión"
              onClick={logout}
            >
              <LogOut size={17} />
            </button>
          </div>
        </header>
        <main className="admin-content">
          {demo && (
            <p className="demo-admin">
              DEMOSTRACIÓN · Cambios guardados solo en este navegador
            </p>
          )}
          {view}
          <div
            className="flex no-print"
            style={{ justifyContent: "space-between", marginTop: 40 }}
          >
            <small>Dilo Shop · 1.0</small>
            <button className="text-button" onClick={() => setHelp(true)}>
              <HelpCircle size={16} /> Ayuda de uso
            </button>
          </div>
        </main>
      </div>
      {menu && (
        <button
          aria-label="Cerrar menú"
          onClick={() => setMenu(false)}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 25,
            background: "transparent",
            border: 0,
          }}
        />
      )}
      {notifications && (
        <Modal
          title="Notificaciones de tu tienda"
          onClose={() => setNotifications(false)}
        >
          <div className="notification-list">
            <h3>Pedidos pendientes ({pending.length})</h3>
            {pending.map((o) => (
              <a
                key={o.id}
                href={`#admin/order/${o.id}`}
                onClick={() => setNotifications(false)}
              >
                <strong>{o.number}</strong> · Pendiente de revisión
                <small>{o.customer_name}</small>
              </a>
            ))}
            <h3>Avisos de inventario ({low.length})</h3>
            {low.map((v) => (
              <a
                key={v.id}
                href="#admin/inventory"
                onClick={() => setNotifications(false)}
              >
                Stock bajo: {v.sku}
                <small>
                  {v.color} · {v.stock} disponibles
                </small>
              </a>
            ))}
            {!pending.length && !low.length && <p>Todo está al día.</p>}
          </div>
        </Modal>
      )}
      {help && (
        <Modal title="Cómo usar tu tienda" onClose={() => setHelp(false)}>
          <div className="stack">
            <p>
              <strong>1. Configura tu tienda.</strong> Completa WhatsApp,
              dirección, banner y datos de Yape, Plin y transferencia.
            </p>
            <p>
              <strong>2. Crea categorías y productos.</strong> Cada producto
              tiene fotos, video y variantes de color con código y stock.
            </p>
            <p>
              <strong>3. Recibe pedidos.</strong> Se reserva el stock al
              crearlos. Aceptado significa que revisaste el pedido; Pagado
              registra el ingreso.
            </p>
            <p>
              <strong>4. Entrega y lleva el control.</strong> Cambia a En ruta o
              Entregado. Si cancelas, las unidades regresan al inventario.
            </p>
            <p>
              <strong>5. Emite recibos.</strong> Abre el detalle del pedido y
              descarga el recibo o la etiqueta. Puedes guardar un PDF desde
              Imprimir.
            </p>
            <p>
              <strong>6. Comparte.</strong> Ver tienda abre la página pública en
              otra pestaña. Cada comprador recibe un correo cuando el envío está
              configurado.
            </p>
          </div>
        </Modal>
      )}
    </div>
  );
}
function Onboarding({ data, user, run, refresh, onUser }) {
  const [name, setName] = useState("Dilo Shop"),
    [token, setToken] = useState(""),
    [busy, setBusy] = useState(false);
  return (
    <div
      className="app-loading"
      style={{
        maxWidth: 650,
        margin: "auto",
        textAlign: "left",
        alignItems: "stretch",
      }}
    >
      <Brand />
      <h1>Conecta tu cuenta con la tienda</h1>
      <p>
        Sesión: {user.email}. Solo el propietario autorizado o sus colaboradores
        pueden administrar Dilo Shop.
      </p>
      {!data?.store && (
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            setBusy(true);
            try {
              await run(
                () =>
                  rpc("create_store", {
                    p_slug: config.storeSlug || "dilo-shop",
                    p_name: name,
                  }),
                "Tienda creada",
              );
              await refresh();
            } catch {
            } finally {
              setBusy(false);
            }
          }}
        >
          <Field
            label="Nombre de tu tienda"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Button disabled={busy}>Crear mi tienda</Button>
          <p className="file-note" style={{ marginTop: 14 }}>
            Autoriza tu correo con 002_propietario.sql antes de este paso.
          </p>
        </form>
      )}
      <form
        className="card"
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          try {
            await run(
              () => rpc("accept_invite", { p_token: token.trim() }),
              "Invitación aceptada",
            );
            await refresh();
          } catch {
          } finally {
            setBusy(false);
          }
        }}
      >
        <h3>¿Eres colaborador?</h3>
        <Field
          label="Código de invitación"
          required
          value={token}
          onChange={(e) => setToken(e.target.value)}
        />
        <Button disabled={busy}>Unirme a la tienda</Button>
      </form>
      <Button
        kind="outline"
        onClick={async () => {
          await supabase.auth.signOut();
          onUser(null);
          location.hash = "#login";
        }}
      >
        Cerrar sesión
      </Button>
    </div>
  );
}
